import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, GitMerge, Server, Layers, Hammer,
  Settings, Zap, LogOut
} from 'lucide-react';
import { clsx } from 'clsx';
import { authApi } from '../../api/client';

const navItems = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/triggers', icon: GitMerge, label: 'Triggers' },
  { to: '/builds', icon: Hammer, label: 'Builds History' },
  { to: '/services', icon: Server, label: 'Services' },
];

export default function Sidebar() {
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await authApi.logout();
    } finally {
      navigate('/login', { replace: true });
    }
  }

  return (
    <aside className="w-[220px] shrink-0 flex flex-col border-r border-slate-200 bg-surface-1 h-full">
      {/* Logo */}
      <div className="px-4 h-14 flex items-center gap-2.5 border-b border-slate-200">
        <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-accent-purple to-accent-cyan flex items-center justify-center">
          <Zap size={14} className="text-white" />
        </div>
        <span className="text-sm font-semibold text-slate-900 tracking-tight">Cloud CI/CD</span>
      </div>

      {/* Nav */}
      <nav className="flex-1 py-3 px-2 space-y-0.5 overflow-y-auto">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              clsx(
                'flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-all group',
                isActive
                  ? 'bg-accent-purple/10 text-accent-purple-light font-medium'
                  : 'text-slate-400 hover:text-slate-900 hover:bg-slate-100'
              )
            }
          >
            <Icon size={16} />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* Settings */}
      <div className="px-2 pb-3 space-y-0.5">
        <button className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-slate-400 hover:text-slate-900 hover:bg-slate-100 transition-colors">
          <Settings size={16} />
          Settings
        </button>
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-slate-400 hover:text-red-600 hover:bg-red-50 transition-colors"
        >
          <LogOut size={16} />
          Log out
        </button>
      </div>
    </aside>
  );
}
